import api from "@/libs/axios";
import axios from "axios";

const graduation = {
  state: {
    list: [],
    metrics: [],
  },
  getters: {
    returnGraduationList: (state) => state.list,
    returnGraduationMetrics: (state) => state.metrics,
  },
  actions: {
    getGraduationReport: async ({ commit }, params) => {
      await api
        .get('/admin/graduation', { params })
        .then((response) => {
          commit("fillReport", response.data);
          resolve(response.data);
        })
        .catch((error) => {
          reject(error.response.data.message);
        });
    },
    payGraduationBonus: async ({ commit }, graduationId) => {
      await api
        .post('/admin/graduation/pay-bonus', { graduationId })
        .then((response) => {
          commit("markAsPaid", graduationId);
          resolve(response.data);
        })
        .catch((error) => {
          reject(error.response.data.message);
        });
    }
  },
  mutations: {
    fillReport: (state, res) => {
      state.list = {
        ...res,
        metrics: undefined,
      };
      state.metrics = res.metrics;
      state.metrics.sort((a, b) => b.count - a.count);
    },
    markAsPaid: (state, graduationId) => {
      const index = state.list.findIndex((item) => item.id === graduationId);
      if (index !== -1) {
        state.list[index].isBonusPaid = true;
      }
    },
  },
};

export default graduation;
